var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGirl4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 1300,
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#A193EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32_1472",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1301,
    height: 1300
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#F7C0B5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32_1472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1014.86 1197.33C1011.83 1199.5 1008.36 1201.66 1005.33 1203.83C1001.86 1206 998.831 1208.16 995.365 1209.9C992.331 1211.63 989.731 1213.36 986.698 1215.1C986.265 1215.53 985.831 1215.53 985.398 1215.96C975.431 1222.03 965.031 1227.66 954.631 1232.86C951.598 1234.6 948.131 1236.33 945.098 1237.63C945.098 1237.63 944.665 1238.06 944.231 1238.06C940.765 1239.8 937.298 1241.53 933.831 1243.26C926.898 1246.73 919.531 1249.76 912.598 1252.8C909.131 1254.53 905.231 1255.83 901.765 1257.13C898.298 1258.43 894.398 1260.16 890.931 1261.46C887.465 1262.76 883.565 1264.5 880.098 1265.8C880.098 1265.8 880.098 1265.8 879.665 1265.8C876.198 1267.1 872.298 1268.4 868.831 1269.7C861.031 1272.3 852.798 1274.9 844.998 1277.5C842.398 1278.36 839.365 1279.23 836.765 1280.1C828.531 1282.7 820.298 1284.86 812.065 1286.6C809.031 1287.46 805.998 1287.9 802.531 1288.76C794.731 1290.5 786.498 1292.23 778.698 1293.96C776.965 1294.4 775.665 1294.4 773.931 1294.83C771.331 1295.26 768.298 1295.7 765.698 1296.13C761.798 1296.56 758.331 1297.43 754.431 1297.86C752.698 1298.3 750.965 1298.3 749.231 1298.73C747.065 1299.16 744.465 1299.6 741.865 1299.6C734.931 1300.46 727.565 1301.33 720.631 1302.2C718.465 1302.63 715.865 1302.63 713.698 1303.06H713.265C710.231 1303.5 707.198 1303.5 704.165 1303.93C701.131 1304.36 698.098 1304.36 695.065 1304.36C693.331 1304.36 691.165 1304.8 689.431 1304.8C685.965 1304.8 682.931 1305.23 679.898 1305.23C675.565 1305.23 671.665 1305.66 667.331 1305.66C662.998 1305.66 659.098 1305.66 654.765 1305.66C651.731 1305.66 648.698 1305.66 645.665 1305.66C463.231 1303.06 298.565 1225.5 181.565 1102.43C181.565 1102.43 181.565 1102 181.131 1102C194.565 1075.56 244.398 1027.9 296.398 988.465C362.265 938.631 455.431 907.865 455.431 907.865C455.431 907.865 516.531 897.898 743.165 945.131C916.065 981.531 989.731 1129.3 1014.86 1197.33Z",
    fill: "#AD827B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.265 1065.16C782.165 1109.8 723.232 1136.23 623.998 1096.36C502.232 1046.96 455.432 907.865 455.432 907.865C448.932 808.198 433.765 722.831 433.765 722.831C574.598 710.698 740.998 875.365 740.998 875.365L760.065 956.831C761.798 963.764 765.265 969.831 770.465 974.165C779.565 989.764 797.332 1036.56 791.265 1065.16Z",
    fill: "#AD827B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.465 974.598C687.698 970.265 626.598 958.131 561.165 840.698C616.631 889.665 682.065 908.298 750.965 916.965L760.065 956.831C761.798 964.198 765.265 970.265 770.465 974.598Z",
    fill: "#8E5650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.631 452.431C949.431 488.831 953.331 518.298 932.098 615.365C910.865 712.431 951.598 809.498 849.331 898.331C780.431 958.131 659.965 969.398 563.765 903.965C531.265 881.865 501.365 851.098 477.098 810.798C458.031 779.165 435.931 749.265 411.231 721.965C376.998 684.698 335.831 609.731 356.198 477.131C389.131 261.331 602.765 236.631 728.865 260.465C854.965 284.298 920.398 356.231 941.631 452.431Z",
    fill: "#AD827B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.931 621.865C526.931 621.865 513.498 556.865 450.231 564.665C395.631 571.598 376.565 702.465 500.498 738.865",
    fill: "#AD827B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.598 679.498C496.598 679.498 480.998 669.531 482.731 652.198C485.331 631.831 482.731 619.265 473.198 615.365C449.365 605.398 444.598 633.131 445.465 636.598",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.231 721.531C827.231 721.531 843.697 722.398 859.297 703.765C867.964 693.365 875.331 680.365 870.564 676.465C865.797 672.131 787.364 684.265 782.164 694.665C776.964 705.065 807.297 721.531 827.231 721.531Z",
    fill: "#8E605C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.232 575.931C840.232 575.931 841.098 617.098 867.532 663.031C879.232 683.398 861.465 716.765 822.898 722.398",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.233 1030.03C872.3 1000.13 828.966 965.033 758.766 946.833C681.2 926.467 640.899 970.233 578.933 964.167C545.566 960.7 490.966 895.7 454.133 905.233C408.633 917.367 358.366 941.633 297.699 983.667C284.699 992.767 173.333 1067.3 134.766 1189.07C99.6661 1299.13 90.9995 1450.8 90.1328 1501.07H1077.27C1077.7 1189.93 939.466 1061.23 905.233 1030.03Z",
    fill: "#FCED7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.834 956.367C439.834 956.367 431.601 884.433 438.967 861.467C439.834 858.433 448.934 853.233 448.934 853.233C448.934 853.233 448.934 893.533 546.434 921.267C649.134 950.3 763.534 941.633 784.767 932.533C784.767 932.533 785.201 992.333 773.934 1014.87C756.601 1049.53 618.801 1042.17 535.167 1013.57C461.934 988.433 439.834 956.367 439.834 956.367Z",
    fill: "#FCED7E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M36.4004 1010.97C124.367 962.433 112.667 1012.7 240.5 988C295.1 977.6 356.634 929.933 435.067 926.467C494.867 923.867 561.167 963.733 634.834 968.933C696.367 973.267 767.434 941.633 838.5 953.333C900.467 963.3 957.667 1015.3 1027 1032.2",
    stroke: "#6D5F5E",
    strokeWidth: 22.5043,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M38.1338 1060.37C133.034 1020.93 117.867 1070.77 247.867 1049.53C304.634 1040.43 368.767 992.333 448.067 988.867C510.034 986.267 578.067 1026.57 653.034 1030.47C716.734 1033.93 788.667 999.7 861.034 1009.67C925.167 1018.33 985.401 1070.33 1056.03 1085.5",
    stroke: "#6D5F5E",
    strokeWidth: 22.5043,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M39.8667 1109.77C140.4 1078.57 122.2 1127.53 254.8 1110.2C313.3 1102.4 380.033 1054.3 460.633 1050.83C524.333 1048.23 594.967 1089.4 670.8 1092.43C736.667 1095.03 809.467 1058.2 883.567 1066.43C949.867 1073.8 1013.13 1125.37 1085.5 1138.37",
    stroke: "#6D5F5E",
    strokeWidth: 22.5043,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M41.6001 1159.17C146.9 1135.77 126.533 1183.87 261.733 1170C322.4 1163.5 391.733 1115.4 473.633 1112.37C539.5 1109.77 611.867 1152.23 689.433 1153.97C757.467 1155.7 831.567 1116.7 906.967 1123.2C975.867 1129.27 1042.17 1179.97 1115.83 1191.23",
    stroke: "#6D5F5E",
    strokeWidth: 22.5043,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M42.9009 1209C152.101 1192.1 130.001 1240.2 267.368 1229.37C330.201 1224.6 402.134 1176.07 485.334 1173.47C553.368 1171.3 627.901 1214.63 706.334 1215.93C776.534 1216.8 851.934 1175.63 928.634 1180.4C999.701 1184.73 1069.47 1235 1144.87 1243.67",
    stroke: "#6D5F5E",
    strokeWidth: 22.5043,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M43.7676 1258.83C156.434 1248 133.034 1295.67 272.568 1288.3C337.568 1284.83 412.101 1236.73 497.034 1235C567.234 1233.27 643.501 1277.9 723.668 1278.33C796.034 1278.77 873.168 1235 950.734 1238.47C1024.83 1241.5 1097.63 1290.9 1173.9 1296.53",
    stroke: "#6D5F5E",
    strokeWidth: 22.5043,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M45.0684 1309.1C160.768 1303.9 136.068 1351.13 278.635 1347.23C345.368 1345.5 422.935 1297.4 509.602 1296.1C581.968 1295.23 660.402 1340.73 741.868 1340.73C816.835 1340.73 895.268 1295.23 974.135 1296.53C1050.83 1297.83 1127.1 1346.37 1204.67 1349.4",
    stroke: "#6D5F5E",
    strokeWidth: 22.5043,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M315.468 975C332.368 994.067 401.702 1076.83 426.402 1170.43L482.302 1179.53C482.302 1179.53 422.502 1030.47 340.168 957.667C336.702 954.633 331.502 954.2 327.168 955.933C323.702 957.667 319.368 960.7 315.468 965.9C312.868 968.933 313.302 972.833 315.468 975Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.568 1150.93C844.568 1150.93 851.935 1039.13 796.035 960.267C796.035 960.267 799.501 956.8 819.001 966.333C832.868 972.833 873.601 1028.73 877.501 1141.83C877.935 1141.83 849.335 1151.37 844.568 1150.93Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.4 1092.87C413.4 1092.87 733.634 1178.23 871.867 1083.77C871.867 1083.77 943.8 1225.47 971.967 1501.07H354.9C354.9 1501.07 405.167 1434.77 413.4 1092.87Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.9 1198.6C483.388 1198.6 492.7 1189.29 492.7 1177.8C492.7 1166.31 483.388 1157 471.9 1157C460.413 1157 451.1 1166.31 451.1 1177.8C451.1 1189.29 460.413 1198.6 471.9 1198.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.7 1165.67C866.751 1165.67 874.899 1157.52 874.899 1147.47C874.899 1137.42 866.751 1129.27 856.7 1129.27C846.648 1129.27 838.5 1137.42 838.5 1147.47C838.5 1157.52 846.648 1165.67 856.7 1165.67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.942 619.439C673.542 619.006 665.742 610.339 666.609 599.939L667.042 587.806C667.475 577.406 676.142 569.606 686.542 570.472C696.942 570.906 704.742 579.572 703.875 589.972L703.442 602.106C703.009 612.072 694.342 619.872 683.942 619.439Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.375 625.939C856.842 625.505 849.475 617.272 849.909 607.739L850.342 596.472C850.775 586.939 859.009 579.572 868.542 580.005C878.075 580.439 885.442 588.672 885.009 598.205L884.575 609.472C884.142 619.005 875.909 626.372 866.375 625.939Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.977 594.305C725.977 594.305 714.71 578.272 695.21 575.239C679.177 572.639 661.41 580.439 658.81 589.539",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.811 598.206C853.811 598.206 853.811 584.339 873.744 584.339C890.211 584.339 897.144 599.506 897.144 599.506",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.743 524.539C752.843 527.572 761.943 519.339 760.21 509.372C759.343 504.172 757.176 498.972 752.843 495.072C739.843 483.372 686.11 472.972 653.61 488.139C625.01 502.005 702.143 510.672 743.743 524.539Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.307 531.472C865.94 534.072 858.14 526.272 859.44 517.172C859.874 512.406 861.607 507.639 865.074 504.172C875.474 493.772 911.007 485.539 933.54 501.572C953.04 515.006 907.107 518.906 873.307 531.472Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.606 771.721C771.997 786.996 726.619 770.373 705.502 744.763",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.76 802.553C984.832 737.987 1019.5 725.42 999.565 676.02C970.098 603.22 972.265 592.82 975.732 576.353C1001.73 453.72 1018.63 321.12 866.965 242.687C696.232 154.287 457.465 190.253 368.632 299.453C293.232 391.32 315.332 439.42 296.265 504.42C277.632 567.253 193.565 568.987 232.132 698.987C251.632 764.853 173.198 799.52 190.532 910.453C311.432 964.62 437.532 990.187 566.232 997.987C601.332 911.753 492.998 892.253 491.698 763.553C491.698 754.887 492.132 746.653 492.998 738.853C372.965 701.153 392.465 572.887 446.632 565.953C484.332 561.187 504.265 582.42 514.232 600.187C515.098 602.787 516.398 604.953 517.698 607.553C534.165 635.72 621.265 610.153 679.765 542.12C742.598 469.32 737.832 474.953 769.465 431.187C833.165 343.653 831.432 433.787 847.465 445.92C869.998 462.82 855.698 475.387 890.798 533.453C906.398 559.453 934.998 585.02 928.065 615.787C906.832 712.42 947.565 809.92 845.298 898.753C822.332 918.687 790.265 936.02 752.565 943.387C754.298 956.387 759.498 975.453 771.198 995.82C860.032 989.753 949.298 977.187 1038.56 962.02C1052.43 913.92 1045.5 856.72 1017.76 802.553Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.132 607.12C516.832 604.953 515.532 602.353 514.665 599.753C515.965 602.353 517.265 604.953 518.132 607.12Z",
    fill: "#FEE4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.066 614.053C941.066 614.053 1055.47 576.786 1012.13 466.72C988.299 406.053 986.999 337.153 962.299 292.953C928.066 231.853 873.466 213.653 792.866 230.553C654.199 259.586 879.099 226.22 892.966 326.32C906.399 426.42 941.066 614.053 941.066 614.053Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.238 697.089L482.605 711.822C483.905 714.422 486.505 716.155 489.105 716.589L505.572 719.189C512.938 720.055 515.538 729.155 510.338 734.355L498.638 746.055C496.472 748.222 495.605 750.822 496.038 753.855L498.638 770.322C499.938 777.689 492.138 782.889 485.638 779.855L470.905 772.055C468.305 770.755 465.272 770.755 462.672 772.055L447.938 779.855C441.438 783.322 433.638 777.689 434.938 770.322L437.538 753.855C437.972 750.822 437.105 748.222 434.938 746.055L423.238 734.355C418.038 729.155 421.072 720.489 428.005 719.189L444.472 716.589C447.505 716.155 449.672 714.422 450.972 711.822L458.338 697.089C462.672 690.155 472.205 690.155 475.238 697.089Z",
    fill: "#FFDE55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.072 745.622C938.905 747.788 938.039 750.822 938.472 753.422L941.072 769.888C942.372 777.255 934.572 782.888 928.072 779.422L919.405 774.655C922.439 753.422 923.305 731.755 923.739 710.088L924.605 711.822C925.905 714.422 928.505 716.155 931.105 716.588L947.572 718.755C954.939 719.622 957.972 728.722 952.339 733.922L941.072 745.622Z",
    fill: "#FFDE55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl4);
export default __webpack_public_path__ + "static/media/Girl_4.09e3c83433e4ba4503f8ec9730ea5d50.svg";
export { ForwardRef as ReactComponent };